// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:wght@400;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* Fonts */
  --main-font: "Montserrat", sans-serif;
  --base-font-size: 1rem;
  --base-line-height: 1.875;

  /* Colors */
  --primary-color: #00205b;
  --primary-color-hsl: 218.9, 100%, 17.84%;
  --primary-color-h: 218.9;
  --primary-color-s: 100%;
  --primary-color-l: 17.84%;
  --primary-color-rgb: 0, 32, 91;

  --secondary-color: #d50037;
  --secondary-color-hsl: 344.51, 100%, 41.76%;
  --secondary-color-h: 344.51;
  --secondary-color-s: 100%;
  --secondary-color-l: 41.76%;
  --secondary-color-rgb: 213, 0, 55;

  --secondary-alt-color: #003da5;
  --secondary-alt-color-hsl: hsl(217.82, 100%, 32.35%);
  --secondary-alt-color-h: 217.82%;
  --secondary-alt-color-s: 100%;
  --secondary-alt-color-l: 32.35%;
  --secondary-alt-color-rgb: 0, 61, 165;

  --accent-color: #ffa400;
  --accent-color-hsl: 38.59, 100%, 50%;
  --accent-color-h: 38.59;
  --accent-color-s: 100%;
  --accent-color-l: 50%;
  --accent-color-rgb: 255, 164, 0;

  --accent-alt-color: #0092e1;
  --accent-alt-color-hsl: 201.07, 100%, 44.12%;
  --accent-alt-color-h: 201.07;
  --accent-alt-color-s: 100%;
  --accent-alt-color-l: 44.12%;
  --accent-alt-color-rgb: 0, 146, 225;

  --black-color: #201f21;
  --black-color-hsl: hsl(270, 3.13%, 12.55%);
  --black-color-h: 270;
  --black-color-s: 3.13%;
  --black-color-l: 12.55%;
  --black-color-rgb: 32, 31, 33;

  --dk-grey-color: #222e34;
  --dk-grey-color-hsl: 200, 20.93%, 16.86%;
  --dk-grey-color-h: 200;
  --dk-grey-color-s: 20.93%;
  --dk-grey-color-l: hsl(0, 0%, 16.86%);
  --dk-grey-color-rgb: 34, 46, 52;

  --md-grey-color: #4d575c;
  --md-grey-color-hsl: 200, 8.88%, 33.14%;
  --md-grey-color-h: 200;
  --md-grey-color-s: 8.88%;
  --md-grey-color-l: 33.14%;
  --md-grey-color-rgb: 77, 87, 92;

  --grey-color: #d0d3d4;
  --grey-color-hsl: 195, 4.44%, 82.35%;
  --grey-color-h: 195;
  --grey-color-s: 4.44%;
  --grey-color-l: 82.35%;
  --grey-color-rgb: 208, 211, 212;

  --lt-grey-color: #e7e9e9;
  --lt-grey-color-hsl: 180, 4.35%, 90.98%;
  --lt-grey-color-h: 180;
  --lt-grey-color-s: 4.35%;
  --lt-grey-color-l: 90.98%;
  --lt-grey-color-rgb: 231, 233, 233;

  --xlt-grey-color: #f6f6f6;
  --xlt-grey-color-hsl: 0, 0%, 96.47%;
  --xlt-grey-color-h: 0;
  --xlt-grey-color-s: 0%;
  --xlt-grey-color-l: 96.47%;
  --xlt-grey-color-rgb: 246, 246, 246;

  --white-color: #ffffff;
  --white-color-hsl: 0, 0%, 100%;
  --white-color-h: 0;
  --white-color-s: 0%;
  --white-color-l: 100%;
  --white-color-rgb: 255, 255, 255;

  --info-color: #1bbc9b;
  --info-color-h: 167.7;
  --info-color-s: 74.88%;
  --info-color-l: 42.16%;

  --caution-color: #ff6517;
  --caution-color-h: 20.17;
  --caution-color-s: 100%;
  --caution-color-l: 54.51%;

  --negative-color: var(--secondary-color);
  --negative-color-h: var(--secondary-color-h);
  --negative-color-s: var(--secondary-color-s);
  --negative-color-l: var(--secondary-color-l);
  --negative-color-rgb: var(--secondary-color-rgb);

  --positive-color: #43a047;
  --positive-color-h: 122.58;
  --positive-color-s: 40.97%;
  --positive-color-l: 44.51%;

  --keyword-color: #e5941a;
  --topic-color: var(--info-color);
  --place-color: #d95f6b;
  --date-color: #5f6bd9;
  --video-color: #ae5ecd;

  --text-dark-color: var(--dk-grey-color);
  --text-lighter-color: #4d575c;
  --text-light-color: var(--white-color);
  --helper-text-color: var(--text-lighter-color);

  --bullet-color: var(--secondary-color);
  --bullet-l2-color: var(--primary-color);
  --bullet-l3-color: var(--accent-alt-color);

  --link-color: var(--accent-alt-color);
  --link-color-visited: hsl(
    var(--accent-alt-color-h),
    calc(var(--accent-alt-color-s) - 40%),
    calc(var(--accent-alt-color-l) + 15%)
  );
  --link-color-hover: var(--secondary-alt-color);
  --link-color-active: var(--primary-color);

  --table-bg-color: none;
  --table-border-color: rgba(var(--dk-grey-color-rgb), 0.3);
  --thead-color: var(--secondary-alt-color);
  --thead-bg-color: none;
  --table-row-light: none;
  --table-row-dark: rgba(var(--dk-grey-color-rgb), 0.1);

  --form-accent-color: var(--accent-alt-color);
  --form-accent-color-rgb: var(--accent-alt-color-rgb);
  --form-accent-color-light: hsl(
    var(--accent-alt-color-h),
    var(--accent-alt-color-s),
    calc(var(--accent-alt-color-l) + 25%)
  );
  --form-accent-color-lighter: hsl(
    var(--accent-alt-color-h),
    var(--accent-alt-color-s),
    calc(var(--accent-alt-color-l) + 52%)
  );

  --form-error-color: var(--negative-color);
  --form-error-color-rgb: var(--negative-color-rgb);
  --form-error-color-light: hsl(
    var(--negative-color-h),
    var(--negative-color-s),
    calc(var(--negative-color-l) + 40%)
  );
  --form-error-color-lighter: hsl(
    var(--negative-color-h),
    var(--negative-color-s),
    calc(var(--negative-color-l) + 52%)
  );
  --form-error-color-darker: hsl(
    var(--negative-color-h),
    calc(var(--negative-color-s) - 20%),
    calc(var(--negative-color-l) - 20%)
  );

  --button-font: var(--main-font);
  --button-font-weight: 700;
  --button-corner-radius: 5rem;
  --button-color: var(--accent-color);
  --button-text-color: var(--primary-color);
  --button-color-hover: hsl(
    var(--accent-color-h),
    var(--accent-color-s),
    calc(var(--accent-color-l) + 20%)
  );
  --button-color-active: var(--button-color-hover);
  --button-shadow: 0 0.125em 0.36em 0 rgba(0, 0, 0, 0);
  --button-shadow-hover: 0 0.125em 0.36em 0 rgba(0, 0, 0, 0.25);
  --button-shadow-active: 0 0.125em 0.36em 0 rgba(0, 0, 0, 0);

  --disabled-bg-color: var(--grey-color);
  --disabled-bg-color-lighter: var(--lt-grey-color);
  --disabled-bg-color-darker: hsl(
    var(--grey-color-h),
    var(--grey-color-s),
    calc(var(--grey-color-l) - 30%)
  );
  --disabled-text-color: hsl(
    var(--grey-color-h),
    var(--grey-color-s),
    calc(var(--grey-color-l) - 40%)
  );
  --disabled-text-color-darker: hsl(
    var(--grey-color-h),
    var(--grey-color-s),
    calc(var(--grey-color-l) - 60%)
  );

  --selection-bg-color: var(--form-accent-color-lighter);
  --selection-bg-color: var(--accent-alt-color);
  --selection-color: var(--white-color);

  --focus-visible-outline-width: 4px;
  --focus-visible-outline-style: solid;
  --focus-visible-outline-color: rgba(var(--form-accent-color-rgb), 0.2);
  --focus-visible-box-shadow: 0 0 0 6px rgba(var(--form-accent-color-rgb), 0.2);

  /* @link https://utopia.fyi/grid/calculator?c=328,16,1.2,2442,20,1.25,5,2,&s=0.75|0.5|0.25,1.5|2|3|4|6|7|8,s-l|xs-l|xs-xl|s-l|s-xl|m-xl|m-2xl|xl-l|4xs-2xl|3xs-2xl|m-5xl|2xs-l|s-5xl|4xs-5xl|l-2xl|3xl-5xl&g=s,xl,3xl,12 */

  /* Utopia Typography */
  /* Step -2: 11.1111px → 12.8px */
  --step--2: clamp(0.6944rem, 0.6781rem + 0.0799cqi, 0.8rem);
  /* Step -1: 13.3333px → 16px */
  --step--1: clamp(0.8333rem, 0.8075rem + 0.1261cqi, 1rem);
  /* Step 0: 16px → 20px */
  --step-0: clamp(1rem, 0.9612rem + 0.1892cqi, 1.25rem);
  /* Step 1: 19.2px → 25px */
  --step-1: clamp(1.2rem, 1.1438rem + 0.2744cqi, 1.5625rem);
  /* Step 2: 23.04px → 31.25px */
  --step-2: clamp(1.44rem, 1.3604rem + 0.3884cqi, 1.9531rem);
  /* Step 3: 27.648px → 39.0625px */
  --step-3: clamp(1.728rem, 1.6173rem + 0.5399cqi, 2.4414rem);
  /* Step 4: 33.1776px → 48.8281px */
  --step-4: clamp(2.0736rem, 1.9218rem + 0.7403cqi, 3.0518rem);
  /* Step 5: 39.8131px → 61.0352px */
  --step-5: clamp(2.4883rem, 2.2825rem + 1.0039cqi, 3.8147rem);

  /* Utopia Space */
  /* Space 4xs: 0px → 0px */
  --space-4xs: clamp(0rem, 0rem + 0cqi, 0rem);
  /* Space 3xs: 4px → 5px */
  --space-3xs: clamp(0.25rem, 0.2403rem + 0.0473cqi, 0.3125rem);
  /* Space 2xs: 8px → 10px */
  --space-2xs: clamp(0.5rem, 0.4806rem + 0.0946cqi, 0.625rem);
  /* Space xs: 12px → 15px */
  --space-xs: clamp(0.75rem, 0.7209rem + 0.1419cqi, 0.9375rem);
  /* Space s: 16px → 20px */
  --space-s: clamp(1rem, 0.9612rem + 0.1892cqi, 1.25rem);
  /* Space m: 24px → 30px */
  --space-m: clamp(1.5rem, 1.4418rem + 0.2838cqi, 1.875rem);
  /* Space l: 32px → 40px */
  --space-l: clamp(2rem, 1.9224rem + 0.3784cqi, 2.5rem);
  /* Space xl: 48px → 60px */
  --space-xl: clamp(3rem, 2.8836rem + 0.5676cqi, 3.75rem);
  /* Space 2xl: 64px → 80px */
  --space-2xl: clamp(4rem, 3.8448rem + 0.7569cqi, 5rem);
  /* Space 3xl: 96px → 120px */
  --space-3xl: clamp(6rem, 5.7673rem + 1.1353cqi, 7.5rem);
  /* Space 4xl: 112px → 140px */
  --space-4xl: clamp(7rem, 6.7285rem + 1.3245cqi, 8.75rem);
  /* Space 5xl: 128px → 160px */
  --space-5xl: clamp(8rem, 7.6897rem + 1.5137cqi, 10rem);

  /* One-up pairs */
  /* Space 4xs-3xs: 0px → 5px */
  --space-4xs-3xs: clamp(0rem, -0.0485rem + 0.2365cqi, 0.3125rem);
  /* Space 3xs-2xs: 4px → 10px */
  --space-3xs-2xs: clamp(0.25rem, 0.1918rem + 0.2838cqi, 0.625rem);
  /* Space 2xs-xs: 8px → 15px */
  --space-2xs-xs: clamp(0.5rem, 0.4321rem + 0.3311cqi, 0.9375rem);
  /* Space xs-s: 12px → 20px */
  --space-xs-s: clamp(0.75rem, 0.6724rem + 0.3784cqi, 1.25rem);
  /* Space s-m: 16px → 30px */
  --space-s-m: clamp(1rem, 0.8642rem + 0.6623cqi, 1.875rem);
  /* Space m-l: 24px → 40px */
  --space-m-l: clamp(1.5rem, 1.3448rem + 0.7569cqi, 2.5rem);
  /* Space l-xl: 32px → 60px */
  --space-l-xl: clamp(2rem, 1.7285rem + 1.3245cqi, 3.75rem);
  /* Space xl-2xl: 48px → 80px */
  --space-xl-2xl: clamp(3rem, 2.6897rem + 1.5137cqi, 5rem);
  /* Space 2xl-3xl: 64px → 120px */
  --space-2xl-3xl: clamp(4rem, 3.457rem + 2.649cqi, 7.5rem);
  /* Space 3xl-4xl: 96px → 140px */
  --space-3xl-4xl: clamp(6rem, 5.5733rem + 2.0814cqi, 8.75rem);
  /* Space 4xl-5xl: 112px → 160px */
  --space-4xl-5xl: clamp(7rem, 6.5345rem + 2.2706cqi, 10rem);

  /* Custom pairs */
  /* Space s-l: 16px → 40px */
  --space-s-l: clamp(1rem, 0.7673rem + 1.1353cqi, 2.5rem);
  /* Space xs-l: 12px → 40px */
  --space-xs-l: clamp(0.75rem, 0.4785rem + 1.3245cqi, 2.5rem);
  /* Space xs-xl: 12px → 60px */
  --space-xs-xl: clamp(0.75rem, 0.2845rem + 2.2706cqi, 3.75rem);
  /* Space s-l: 16px → 40px */
  --space-s-l: clamp(1rem, 0.7673rem + 1.1353cqi, 2.5rem);
  /* Space s-xl: 16px → 60px */
  --space-s-xl: clamp(1rem, 0.5733rem + 2.0814cqi, 3.75rem);
  /* Space m-xl: 24px → 60px */
  --space-m-xl: clamp(1.5rem, 1.1509rem + 1.7029cqi, 3.75rem);
  /* Space m-2xl: 24px → 80px */
  --space-m-2xl: clamp(1.5rem, 0.957rem + 2.649cqi, 5rem);
  /* Space xl-l: 48px → 40px */
  --space-xl-l: clamp(2.5rem, 3.0776rem + -0.3784cqi, 3rem);
  /* Space 3xs-2xl: 4px → 80px */
  --space-3xs-2xl: clamp(0.25rem, -0.487rem + 3.5951cqi, 5rem);
  /* Space m-5xl: 24px → 160px */
  --space-m-5xl: clamp(1.5rem, 0.1812rem + 6.4333cqi, 10rem);
  /* Space 2xs-l: 8px → 40px */
  --space-2xs-l: clamp(0.5rem, 0.1897rem + 1.5137cqi, 2.5rem);
  /* Space s-5xl: 16px → 160px */
  --space-s-5xl: clamp(1rem, -0.3964rem + 6.8117cqi, 10rem);
  /* Space l-2xl: 32px → 80px */
  --space-l-2xl: clamp(2rem, 1.5345rem + 2.2706cqi, 5rem);
  /* Space 3xl-5xl: 96px → 160px */
  --space-3xl-5xl: clamp(6rem, 5.3794rem + 3.0274cqi, 10rem);

  /* Utopia Grid */
  --grid-max-width: 138.75rem;
  --grid-gutter: var(--space-s-xl, clamp(1rem, 0.5233rem + 2.3256vw, 3.75rem));
  --grid-columns: 12;

  /* Global Nav */
  --global-nav-bg-color: var(--xlt-grey-color);
  --global-nav-transition: all 0.25s ease-in-out;
  --global-nav-height: calc(var(--space-l) + var(--space-3xs));
  --global-nav-link-color: var(--primary-color);
  --global-nav-link-color-hover: var(--secondary-color);
  --global-nav-link-color-active: hsl(
    var(--secondary-color-h),
    var(--secondary-color-s),
    calc(var(--secondary-color-l) - 10%)
  );
  --global-nav-link-color-focus: var(--secondary-color);
  --global-nav-menu-color: var(--secondary-alt-color);
  --global-nav-menu-color-hover: var(--secondary-color);
  --global-nav-menu-color-active: hsl(
    var(--secondary-color-h),
    var(--secondary-color-s),
    calc(var(--secondary-color-l) - 10%)
  );
  --global-nav-link-color-focus: var(--secondary-color);
  --global-subnav-clip-open: polygon(0 0, 130% 0, 130% 130%, 0 130%);
  --global-subnav-clip-shut: polygon(0 0, 130% 0, 130% 0, 0 0);

  /* Results Page */
  --results-nav-height: calc(var(--space-2xl) + var(--space-4xs));
}

form {
  --input-bg-color: rgba(255, 255, 255, 0.85);
  --input-bg-color-transparent: rgba(255, 255, 255, 0.75);
  --input-bg-color-darker: hsl(
    var(--primary-color-h),
    var(--primary-color-s),
    calc(var(--primary-color-l) + 72%)
  );
  --input-bg-color-hover: var(--form-accent-color-lighter);
  --input-bg-color-focus: var(--input-bg-color);
}
`, "",{"version":3,"sources":["webpack://./src/layout/Variables.css"],"names":[],"mappings":"AACA;EACE,UAAU;EACV,qCAAqC;EACrC,sBAAsB;EACtB,yBAAyB;;EAEzB,WAAW;EACX,wBAAwB;EACxB,wCAAwC;EACxC,wBAAwB;EACxB,uBAAuB;EACvB,yBAAyB;EACzB,8BAA8B;;EAE9B,0BAA0B;EAC1B,2CAA2C;EAC3C,2BAA2B;EAC3B,yBAAyB;EACzB,2BAA2B;EAC3B,iCAAiC;;EAEjC,8BAA8B;EAC9B,oDAAoD;EACpD,gCAAgC;EAChC,6BAA6B;EAC7B,+BAA+B;EAC/B,qCAAqC;;EAErC,uBAAuB;EACvB,oCAAoC;EACpC,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,+BAA+B;;EAE/B,2BAA2B;EAC3B,4CAA4C;EAC5C,4BAA4B;EAC5B,0BAA0B;EAC1B,4BAA4B;EAC5B,mCAAmC;;EAEnC,sBAAsB;EACtB,0CAA0C;EAC1C,oBAAoB;EACpB,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;;EAE7B,wBAAwB;EACxB,wCAAwC;EACxC,sBAAsB;EACtB,yBAAyB;EACzB,qCAAqC;EACrC,+BAA+B;;EAE/B,wBAAwB;EACxB,uCAAuC;EACvC,sBAAsB;EACtB,wBAAwB;EACxB,yBAAyB;EACzB,+BAA+B;;EAE/B,qBAAqB;EACrB,oCAAoC;EACpC,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;EACtB,+BAA+B;;EAE/B,wBAAwB;EACxB,uCAAuC;EACvC,sBAAsB;EACtB,wBAAwB;EACxB,yBAAyB;EACzB,kCAAkC;;EAElC,yBAAyB;EACzB,mCAAmC;EACnC,qBAAqB;EACrB,sBAAsB;EACtB,0BAA0B;EAC1B,mCAAmC;;EAEnC,sBAAsB;EACtB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,gCAAgC;;EAEhC,qBAAqB;EACrB,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;;EAEtB,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;EACvB,yBAAyB;;EAEzB,wCAAwC;EACxC,4CAA4C;EAC5C,4CAA4C;EAC5C,4CAA4C;EAC5C,gDAAgD;;EAEhD,yBAAyB;EACzB,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;;EAE1B,wBAAwB;EACxB,gCAAgC;EAChC,sBAAsB;EACtB,qBAAqB;EACrB,sBAAsB;;EAEtB,uCAAuC;EACvC,6BAA6B;EAC7B,sCAAsC;EACtC,8CAA8C;;EAE9C,sCAAsC;EACtC,uCAAuC;EACvC,0CAA0C;;EAE1C,qCAAqC;EACrC;;;;GAIC;EACD,8CAA8C;EAC9C,yCAAyC;;EAEzC,sBAAsB;EACtB,yDAAyD;EACzD,yCAAyC;EACzC,sBAAsB;EACtB,uBAAuB;EACvB,qDAAqD;;EAErD,4CAA4C;EAC5C,oDAAoD;EACpD;;;;GAIC;EACD;;;;GAIC;;EAED,yCAAyC;EACzC,iDAAiD;EACjD;;;;GAIC;EACD;;;;GAIC;EACD;;;;GAIC;;EAED,+BAA+B;EAC/B,yBAAyB;EACzB,4BAA4B;EAC5B,mCAAmC;EACnC,yCAAyC;EACzC;;;;GAIC;EACD,gDAAgD;EAChD,oDAAoD;EACpD,6DAA6D;EAC7D,2DAA2D;;EAE3D,sCAAsC;EACtC,iDAAiD;EACjD;;;;GAIC;EACD;;;;GAIC;EACD;;;;GAIC;;EAED,sDAAsD;EACtD,6CAA6C;EAC7C,qCAAqC;;EAErC,kCAAkC;EAClC,oCAAoC;EACpC,sEAAsE;EACtE,6EAA6E;;EAE7E,0NAA0N;;EAE1N,sBAAsB;EACtB,gCAAgC;EAChC,0DAA0D;EAC1D,8BAA8B;EAC9B,wDAAwD;EACxD,wBAAwB;EACxB,qDAAqD;EACrD,0BAA0B;EAC1B,yDAAyD;EACzD,8BAA8B;EAC9B,0DAA0D;EAC1D,iCAAiC;EACjC,2DAA2D;EAC3D,kCAAkC;EAClC,4DAA4D;EAC5D,kCAAkC;EAClC,4DAA4D;;EAE5D,iBAAiB;EACjB,yBAAyB;EACzB,2CAA2C;EAC3C,yBAAyB;EACzB,6DAA6D;EAC7D,0BAA0B;EAC1B,2DAA2D;EAC3D,0BAA0B;EAC1B,4DAA4D;EAC5D,yBAAyB;EACzB,sDAAsD;EACtD,yBAAyB;EACzB,yDAAyD;EACzD,yBAAyB;EACzB,qDAAqD;EACrD,0BAA0B;EAC1B,uDAAuD;EACvD,2BAA2B;EAC3B,qDAAqD;EACrD,4BAA4B;EAC5B,uDAAuD;EACvD,6BAA6B;EAC7B,wDAAwD;EACxD,6BAA6B;EAC7B,sDAAsD;;EAEtD,iBAAiB;EACjB,6BAA6B;EAC7B,+DAA+D;EAC/D,8BAA8B;EAC9B,gEAAgE;EAChE,6BAA6B;EAC7B,+DAA+D;EAC/D,4BAA4B;EAC5B,4DAA4D;EAC5D,2BAA2B;EAC3B,yDAAyD;EACzD,2BAA2B;EAC3B,yDAAyD;EACzD,4BAA4B;EAC5B,yDAAyD;EACzD,8BAA8B;EAC9B,wDAAwD;EACxD,gCAAgC;EAChC,yDAAyD;EACzD,gCAAgC;EAChC,4DAA4D;EAC5D,iCAAiC;EACjC,0DAA0D;;EAE1D,iBAAiB;EACjB,2BAA2B;EAC3B,uDAAuD;EACvD,4BAA4B;EAC5B,2DAA2D;EAC3D,6BAA6B;EAC7B,6DAA6D;EAC7D,2BAA2B;EAC3B,uDAAuD;EACvD,4BAA4B;EAC5B,yDAAyD;EACzD,4BAA4B;EAC5B,2DAA2D;EAC3D,6BAA6B;EAC7B,uDAAuD;EACvD,4BAA4B;EAC5B,yDAAyD;EACzD,8BAA8B;EAC9B,4DAA4D;EAC5D,8BAA8B;EAC9B,0DAA0D;EAC1D,4BAA4B;EAC5B,2DAA2D;EAC3D,8BAA8B;EAC9B,yDAAyD;EACzD,6BAA6B;EAC7B,uDAAuD;EACvD,gCAAgC;EAChC,0DAA0D;;EAE1D,gBAAgB;EAChB,2BAA2B;EAC3B,4EAA4E;EAC5E,kBAAkB;;EAElB,eAAe;EACf,4CAA4C;EAC5C,8CAA8C;EAC9C,4DAA4D;EAC5D,6CAA6C;EAC7C,qDAAqD;EACrD;;;;GAIC;EACD,qDAAqD;EACrD,mDAAmD;EACnD,qDAAqD;EACrD;;;;GAIC;EACD,qDAAqD;EACrD,kEAAkE;EAClE,4DAA4D;;EAE5D,iBAAiB;EACjB,+DAA+D;AACjE;;AAEA;EACE,2CAA2C;EAC3C,uDAAuD;EACvD;;;;GAIC;EACD,wDAAwD;EACxD,6CAA6C;AAC/C","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Montserrat:wght@400;700&display=swap\");\n:root {\n  /* Fonts */\n  --main-font: \"Montserrat\", sans-serif;\n  --base-font-size: 1rem;\n  --base-line-height: 1.875;\n\n  /* Colors */\n  --primary-color: #00205b;\n  --primary-color-hsl: 218.9, 100%, 17.84%;\n  --primary-color-h: 218.9;\n  --primary-color-s: 100%;\n  --primary-color-l: 17.84%;\n  --primary-color-rgb: 0, 32, 91;\n\n  --secondary-color: #d50037;\n  --secondary-color-hsl: 344.51, 100%, 41.76%;\n  --secondary-color-h: 344.51;\n  --secondary-color-s: 100%;\n  --secondary-color-l: 41.76%;\n  --secondary-color-rgb: 213, 0, 55;\n\n  --secondary-alt-color: #003da5;\n  --secondary-alt-color-hsl: hsl(217.82, 100%, 32.35%);\n  --secondary-alt-color-h: 217.82%;\n  --secondary-alt-color-s: 100%;\n  --secondary-alt-color-l: 32.35%;\n  --secondary-alt-color-rgb: 0, 61, 165;\n\n  --accent-color: #ffa400;\n  --accent-color-hsl: 38.59, 100%, 50%;\n  --accent-color-h: 38.59;\n  --accent-color-s: 100%;\n  --accent-color-l: 50%;\n  --accent-color-rgb: 255, 164, 0;\n\n  --accent-alt-color: #0092e1;\n  --accent-alt-color-hsl: 201.07, 100%, 44.12%;\n  --accent-alt-color-h: 201.07;\n  --accent-alt-color-s: 100%;\n  --accent-alt-color-l: 44.12%;\n  --accent-alt-color-rgb: 0, 146, 225;\n\n  --black-color: #201f21;\n  --black-color-hsl: hsl(270, 3.13%, 12.55%);\n  --black-color-h: 270;\n  --black-color-s: 3.13%;\n  --black-color-l: 12.55%;\n  --black-color-rgb: 32, 31, 33;\n\n  --dk-grey-color: #222e34;\n  --dk-grey-color-hsl: 200, 20.93%, 16.86%;\n  --dk-grey-color-h: 200;\n  --dk-grey-color-s: 20.93%;\n  --dk-grey-color-l: hsl(0, 0%, 16.86%);\n  --dk-grey-color-rgb: 34, 46, 52;\n\n  --md-grey-color: #4d575c;\n  --md-grey-color-hsl: 200, 8.88%, 33.14%;\n  --md-grey-color-h: 200;\n  --md-grey-color-s: 8.88%;\n  --md-grey-color-l: 33.14%;\n  --md-grey-color-rgb: 77, 87, 92;\n\n  --grey-color: #d0d3d4;\n  --grey-color-hsl: 195, 4.44%, 82.35%;\n  --grey-color-h: 195;\n  --grey-color-s: 4.44%;\n  --grey-color-l: 82.35%;\n  --grey-color-rgb: 208, 211, 212;\n\n  --lt-grey-color: #e7e9e9;\n  --lt-grey-color-hsl: 180, 4.35%, 90.98%;\n  --lt-grey-color-h: 180;\n  --lt-grey-color-s: 4.35%;\n  --lt-grey-color-l: 90.98%;\n  --lt-grey-color-rgb: 231, 233, 233;\n\n  --xlt-grey-color: #f6f6f6;\n  --xlt-grey-color-hsl: 0, 0%, 96.47%;\n  --xlt-grey-color-h: 0;\n  --xlt-grey-color-s: 0%;\n  --xlt-grey-color-l: 96.47%;\n  --xlt-grey-color-rgb: 246, 246, 246;\n\n  --white-color: #ffffff;\n  --white-color-hsl: 0, 0%, 100%;\n  --white-color-h: 0;\n  --white-color-s: 0%;\n  --white-color-l: 100%;\n  --white-color-rgb: 255, 255, 255;\n\n  --info-color: #1bbc9b;\n  --info-color-h: 167.7;\n  --info-color-s: 74.88%;\n  --info-color-l: 42.16%;\n\n  --caution-color: #ff6517;\n  --caution-color-h: 20.17;\n  --caution-color-s: 100%;\n  --caution-color-l: 54.51%;\n\n  --negative-color: var(--secondary-color);\n  --negative-color-h: var(--secondary-color-h);\n  --negative-color-s: var(--secondary-color-s);\n  --negative-color-l: var(--secondary-color-l);\n  --negative-color-rgb: var(--secondary-color-rgb);\n\n  --positive-color: #43a047;\n  --positive-color-h: 122.58;\n  --positive-color-s: 40.97%;\n  --positive-color-l: 44.51%;\n\n  --keyword-color: #e5941a;\n  --topic-color: var(--info-color);\n  --place-color: #d95f6b;\n  --date-color: #5f6bd9;\n  --video-color: #ae5ecd;\n\n  --text-dark-color: var(--dk-grey-color);\n  --text-lighter-color: #4d575c;\n  --text-light-color: var(--white-color);\n  --helper-text-color: var(--text-lighter-color);\n\n  --bullet-color: var(--secondary-color);\n  --bullet-l2-color: var(--primary-color);\n  --bullet-l3-color: var(--accent-alt-color);\n\n  --link-color: var(--accent-alt-color);\n  --link-color-visited: hsl(\n    var(--accent-alt-color-h),\n    calc(var(--accent-alt-color-s) - 40%),\n    calc(var(--accent-alt-color-l) + 15%)\n  );\n  --link-color-hover: var(--secondary-alt-color);\n  --link-color-active: var(--primary-color);\n\n  --table-bg-color: none;\n  --table-border-color: rgba(var(--dk-grey-color-rgb), 0.3);\n  --thead-color: var(--secondary-alt-color);\n  --thead-bg-color: none;\n  --table-row-light: none;\n  --table-row-dark: rgba(var(--dk-grey-color-rgb), 0.1);\n\n  --form-accent-color: var(--accent-alt-color);\n  --form-accent-color-rgb: var(--accent-alt-color-rgb);\n  --form-accent-color-light: hsl(\n    var(--accent-alt-color-h),\n    var(--accent-alt-color-s),\n    calc(var(--accent-alt-color-l) + 25%)\n  );\n  --form-accent-color-lighter: hsl(\n    var(--accent-alt-color-h),\n    var(--accent-alt-color-s),\n    calc(var(--accent-alt-color-l) + 52%)\n  );\n\n  --form-error-color: var(--negative-color);\n  --form-error-color-rgb: var(--negative-color-rgb);\n  --form-error-color-light: hsl(\n    var(--negative-color-h),\n    var(--negative-color-s),\n    calc(var(--negative-color-l) + 40%)\n  );\n  --form-error-color-lighter: hsl(\n    var(--negative-color-h),\n    var(--negative-color-s),\n    calc(var(--negative-color-l) + 52%)\n  );\n  --form-error-color-darker: hsl(\n    var(--negative-color-h),\n    calc(var(--negative-color-s) - 20%),\n    calc(var(--negative-color-l) - 20%)\n  );\n\n  --button-font: var(--main-font);\n  --button-font-weight: 700;\n  --button-corner-radius: 5rem;\n  --button-color: var(--accent-color);\n  --button-text-color: var(--primary-color);\n  --button-color-hover: hsl(\n    var(--accent-color-h),\n    var(--accent-color-s),\n    calc(var(--accent-color-l) + 20%)\n  );\n  --button-color-active: var(--button-color-hover);\n  --button-shadow: 0 0.125em 0.36em 0 rgba(0, 0, 0, 0);\n  --button-shadow-hover: 0 0.125em 0.36em 0 rgba(0, 0, 0, 0.25);\n  --button-shadow-active: 0 0.125em 0.36em 0 rgba(0, 0, 0, 0);\n\n  --disabled-bg-color: var(--grey-color);\n  --disabled-bg-color-lighter: var(--lt-grey-color);\n  --disabled-bg-color-darker: hsl(\n    var(--grey-color-h),\n    var(--grey-color-s),\n    calc(var(--grey-color-l) - 30%)\n  );\n  --disabled-text-color: hsl(\n    var(--grey-color-h),\n    var(--grey-color-s),\n    calc(var(--grey-color-l) - 40%)\n  );\n  --disabled-text-color-darker: hsl(\n    var(--grey-color-h),\n    var(--grey-color-s),\n    calc(var(--grey-color-l) - 60%)\n  );\n\n  --selection-bg-color: var(--form-accent-color-lighter);\n  --selection-bg-color: var(--accent-alt-color);\n  --selection-color: var(--white-color);\n\n  --focus-visible-outline-width: 4px;\n  --focus-visible-outline-style: solid;\n  --focus-visible-outline-color: rgba(var(--form-accent-color-rgb), 0.2);\n  --focus-visible-box-shadow: 0 0 0 6px rgba(var(--form-accent-color-rgb), 0.2);\n\n  /* @link https://utopia.fyi/grid/calculator?c=328,16,1.2,2442,20,1.25,5,2,&s=0.75|0.5|0.25,1.5|2|3|4|6|7|8,s-l|xs-l|xs-xl|s-l|s-xl|m-xl|m-2xl|xl-l|4xs-2xl|3xs-2xl|m-5xl|2xs-l|s-5xl|4xs-5xl|l-2xl|3xl-5xl&g=s,xl,3xl,12 */\n\n  /* Utopia Typography */\n  /* Step -2: 11.1111px → 12.8px */\n  --step--2: clamp(0.6944rem, 0.6781rem + 0.0799cqi, 0.8rem);\n  /* Step -1: 13.3333px → 16px */\n  --step--1: clamp(0.8333rem, 0.8075rem + 0.1261cqi, 1rem);\n  /* Step 0: 16px → 20px */\n  --step-0: clamp(1rem, 0.9612rem + 0.1892cqi, 1.25rem);\n  /* Step 1: 19.2px → 25px */\n  --step-1: clamp(1.2rem, 1.1438rem + 0.2744cqi, 1.5625rem);\n  /* Step 2: 23.04px → 31.25px */\n  --step-2: clamp(1.44rem, 1.3604rem + 0.3884cqi, 1.9531rem);\n  /* Step 3: 27.648px → 39.0625px */\n  --step-3: clamp(1.728rem, 1.6173rem + 0.5399cqi, 2.4414rem);\n  /* Step 4: 33.1776px → 48.8281px */\n  --step-4: clamp(2.0736rem, 1.9218rem + 0.7403cqi, 3.0518rem);\n  /* Step 5: 39.8131px → 61.0352px */\n  --step-5: clamp(2.4883rem, 2.2825rem + 1.0039cqi, 3.8147rem);\n\n  /* Utopia Space */\n  /* Space 4xs: 0px → 0px */\n  --space-4xs: clamp(0rem, 0rem + 0cqi, 0rem);\n  /* Space 3xs: 4px → 5px */\n  --space-3xs: clamp(0.25rem, 0.2403rem + 0.0473cqi, 0.3125rem);\n  /* Space 2xs: 8px → 10px */\n  --space-2xs: clamp(0.5rem, 0.4806rem + 0.0946cqi, 0.625rem);\n  /* Space xs: 12px → 15px */\n  --space-xs: clamp(0.75rem, 0.7209rem + 0.1419cqi, 0.9375rem);\n  /* Space s: 16px → 20px */\n  --space-s: clamp(1rem, 0.9612rem + 0.1892cqi, 1.25rem);\n  /* Space m: 24px → 30px */\n  --space-m: clamp(1.5rem, 1.4418rem + 0.2838cqi, 1.875rem);\n  /* Space l: 32px → 40px */\n  --space-l: clamp(2rem, 1.9224rem + 0.3784cqi, 2.5rem);\n  /* Space xl: 48px → 60px */\n  --space-xl: clamp(3rem, 2.8836rem + 0.5676cqi, 3.75rem);\n  /* Space 2xl: 64px → 80px */\n  --space-2xl: clamp(4rem, 3.8448rem + 0.7569cqi, 5rem);\n  /* Space 3xl: 96px → 120px */\n  --space-3xl: clamp(6rem, 5.7673rem + 1.1353cqi, 7.5rem);\n  /* Space 4xl: 112px → 140px */\n  --space-4xl: clamp(7rem, 6.7285rem + 1.3245cqi, 8.75rem);\n  /* Space 5xl: 128px → 160px */\n  --space-5xl: clamp(8rem, 7.6897rem + 1.5137cqi, 10rem);\n\n  /* One-up pairs */\n  /* Space 4xs-3xs: 0px → 5px */\n  --space-4xs-3xs: clamp(0rem, -0.0485rem + 0.2365cqi, 0.3125rem);\n  /* Space 3xs-2xs: 4px → 10px */\n  --space-3xs-2xs: clamp(0.25rem, 0.1918rem + 0.2838cqi, 0.625rem);\n  /* Space 2xs-xs: 8px → 15px */\n  --space-2xs-xs: clamp(0.5rem, 0.4321rem + 0.3311cqi, 0.9375rem);\n  /* Space xs-s: 12px → 20px */\n  --space-xs-s: clamp(0.75rem, 0.6724rem + 0.3784cqi, 1.25rem);\n  /* Space s-m: 16px → 30px */\n  --space-s-m: clamp(1rem, 0.8642rem + 0.6623cqi, 1.875rem);\n  /* Space m-l: 24px → 40px */\n  --space-m-l: clamp(1.5rem, 1.3448rem + 0.7569cqi, 2.5rem);\n  /* Space l-xl: 32px → 60px */\n  --space-l-xl: clamp(2rem, 1.7285rem + 1.3245cqi, 3.75rem);\n  /* Space xl-2xl: 48px → 80px */\n  --space-xl-2xl: clamp(3rem, 2.6897rem + 1.5137cqi, 5rem);\n  /* Space 2xl-3xl: 64px → 120px */\n  --space-2xl-3xl: clamp(4rem, 3.457rem + 2.649cqi, 7.5rem);\n  /* Space 3xl-4xl: 96px → 140px */\n  --space-3xl-4xl: clamp(6rem, 5.5733rem + 2.0814cqi, 8.75rem);\n  /* Space 4xl-5xl: 112px → 160px */\n  --space-4xl-5xl: clamp(7rem, 6.5345rem + 2.2706cqi, 10rem);\n\n  /* Custom pairs */\n  /* Space s-l: 16px → 40px */\n  --space-s-l: clamp(1rem, 0.7673rem + 1.1353cqi, 2.5rem);\n  /* Space xs-l: 12px → 40px */\n  --space-xs-l: clamp(0.75rem, 0.4785rem + 1.3245cqi, 2.5rem);\n  /* Space xs-xl: 12px → 60px */\n  --space-xs-xl: clamp(0.75rem, 0.2845rem + 2.2706cqi, 3.75rem);\n  /* Space s-l: 16px → 40px */\n  --space-s-l: clamp(1rem, 0.7673rem + 1.1353cqi, 2.5rem);\n  /* Space s-xl: 16px → 60px */\n  --space-s-xl: clamp(1rem, 0.5733rem + 2.0814cqi, 3.75rem);\n  /* Space m-xl: 24px → 60px */\n  --space-m-xl: clamp(1.5rem, 1.1509rem + 1.7029cqi, 3.75rem);\n  /* Space m-2xl: 24px → 80px */\n  --space-m-2xl: clamp(1.5rem, 0.957rem + 2.649cqi, 5rem);\n  /* Space xl-l: 48px → 40px */\n  --space-xl-l: clamp(2.5rem, 3.0776rem + -0.3784cqi, 3rem);\n  /* Space 3xs-2xl: 4px → 80px */\n  --space-3xs-2xl: clamp(0.25rem, -0.487rem + 3.5951cqi, 5rem);\n  /* Space m-5xl: 24px → 160px */\n  --space-m-5xl: clamp(1.5rem, 0.1812rem + 6.4333cqi, 10rem);\n  /* Space 2xs-l: 8px → 40px */\n  --space-2xs-l: clamp(0.5rem, 0.1897rem + 1.5137cqi, 2.5rem);\n  /* Space s-5xl: 16px → 160px */\n  --space-s-5xl: clamp(1rem, -0.3964rem + 6.8117cqi, 10rem);\n  /* Space l-2xl: 32px → 80px */\n  --space-l-2xl: clamp(2rem, 1.5345rem + 2.2706cqi, 5rem);\n  /* Space 3xl-5xl: 96px → 160px */\n  --space-3xl-5xl: clamp(6rem, 5.3794rem + 3.0274cqi, 10rem);\n\n  /* Utopia Grid */\n  --grid-max-width: 138.75rem;\n  --grid-gutter: var(--space-s-xl, clamp(1rem, 0.5233rem + 2.3256vw, 3.75rem));\n  --grid-columns: 12;\n\n  /* Global Nav */\n  --global-nav-bg-color: var(--xlt-grey-color);\n  --global-nav-transition: all 0.25s ease-in-out;\n  --global-nav-height: calc(var(--space-l) + var(--space-3xs));\n  --global-nav-link-color: var(--primary-color);\n  --global-nav-link-color-hover: var(--secondary-color);\n  --global-nav-link-color-active: hsl(\n    var(--secondary-color-h),\n    var(--secondary-color-s),\n    calc(var(--secondary-color-l) - 10%)\n  );\n  --global-nav-link-color-focus: var(--secondary-color);\n  --global-nav-menu-color: var(--secondary-alt-color);\n  --global-nav-menu-color-hover: var(--secondary-color);\n  --global-nav-menu-color-active: hsl(\n    var(--secondary-color-h),\n    var(--secondary-color-s),\n    calc(var(--secondary-color-l) - 10%)\n  );\n  --global-nav-link-color-focus: var(--secondary-color);\n  --global-subnav-clip-open: polygon(0 0, 130% 0, 130% 130%, 0 130%);\n  --global-subnav-clip-shut: polygon(0 0, 130% 0, 130% 0, 0 0);\n\n  /* Results Page */\n  --results-nav-height: calc(var(--space-2xl) + var(--space-4xs));\n}\n\nform {\n  --input-bg-color: rgba(255, 255, 255, 0.85);\n  --input-bg-color-transparent: rgba(255, 255, 255, 0.75);\n  --input-bg-color-darker: hsl(\n    var(--primary-color-h),\n    var(--primary-color-s),\n    calc(var(--primary-color-l) + 72%)\n  );\n  --input-bg-color-hover: var(--form-accent-color-lighter);\n  --input-bg-color-focus: var(--input-bg-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
